import(/* webpackMode: "eager" */ "/vercel/path0/src/app/workforce-solutions/page.tsx");
